import styled from 'styled-components';

import Table from 'src/components/Table';

export const StyledTable = styled(Table)`
  .cursor-pointer {
    cursor: pointer;
  }
`;
